import { render, staticRenderFns } from "./PdfModal.vue?vue&type=template&id=446d1d7d&scoped=true&"
import script from "./PdfModal.vue?vue&type=script&lang=js&"
export * from "./PdfModal.vue?vue&type=script&lang=js&"
import style0 from "./PdfModal.vue?vue&type=style&index=0&id=446d1d7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d1d7d",
  null
  
)

export default component.exports